// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import styles from './Section.module.css';

interface SectionProps {
  label: string;
  openLabel: string;
  onOpen: () => void;
  loading?: boolean;
  error?: string | null;
  /** Shown above the content when it loaded but is partial or capped. */
  notice?: string | null;
  /** Shown as a Retry button beside the notice when the partial load can recover. */
  onRetry?: (() => void) | null;
  /** True when this section isn't backed by a real endpoint yet. */
  mocked?: boolean;
  children: React.ReactNode;
}

export default function Section({
  label,
  openLabel,
  onOpen,
  loading = false,
  error = null,
  notice = null,
  onRetry = null,
  mocked = false,
  children,
}: SectionProps) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHead}>
        <h2 className={styles.sectionLabel}>
          {label}
          {mocked && <span className={styles.mockedBadge}>Mocked</span>}
        </h2>
        <button type="button" className={styles.sectionLink} onClick={onOpen}>
          {openLabel}
        </button>
      </div>
      {error ? (
        <div className={styles.status}>{error}</div>
      ) : loading ? (
        <div className={styles.status}>Loading…</div>
      ) : (
        <>
          {notice && (
            <div className={styles.status} role="status">
              {notice}
              {onRetry && (
                <>
                  {' '}
                  <button type="button" className={styles.sectionLink} onClick={onRetry}>
                    Retry
                  </button>
                </>
              )}
            </div>
          )}
          {children}
        </>
      )}
    </section>
  );
}
